import debounce from "lodash.debounce";
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import {
  ToastType,
  useToast,
} from "../../../context_providers/toast/toast_ctx";
import { fetchGet, toQueryString } from "../../../service/api_client";
import AutoCompleteField from "../../../ui/new_components/common/autocomplete";
import ModalDialog from "../../../ui/pages/content_panel/ui/new_components/common/modal";
import { UnitMeasureModel } from "../models/item_unit_model";
import ItemUnitCreateScreen from "./item_unit_create_screen";

interface ItemUnitSearchFieldProps {
  onSelect: (data: UnitMeasureModel) => void;
  disabled?: boolean;
  placeholder?: string;
  value?: UnitMeasureModel;
}

const ItemUnitSearchField: FunctionComponent<ItemUnitSearchFieldProps> = (
  props,
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/units`;
  const { showToast } = useToast();
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [addNew, setAddNew] = useState(false);
  const [data, setData] = useState<UnitMeasureModel[]>();
  const getData = async (prop: {
    search?: string;
    page: number;
    count: number;
    all?: boolean;
  }) => {
    setLoading(true);
    try {
      const res = await fetchGet(url + toQueryString(prop));
      if (res.success) {
        setData(res.data.data);
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };

  const debouncedHandler = useCallback(
    debounce((query) => {
      if (query) getData({ search: query, page: 1, count: 1, all: true });
      else setData(undefined);
    }, 500),
    [],
  );

  useEffect(() => {
    if (search && edit) {
      if (props.value && props.value.symbol === search) return;
      debouncedHandler(search);
    }
  }, [search]);
  useEffect(() => {
    setSearch(props.value?.symbol ?? "");
  }, [props.value]);
  return (
    <div id="item_unit_search_container" className="flex gap-1 items-center    w-full">
      {edit ? (
        <AutoCompleteField
          onAddNew={() => {
            setAddNew(true);
          }}
          loading={loading}
          value={search}
          placeholder={props.placeholder ?? "Select "}
          onSelect={(val) => {
            setEdit(false);
            setSearch(val.value.symbol);
            props.onSelect(val.value);
          }}
          suggestions={data?.map((d) => ({
            label: (
              <div className="text-xs">
                <b>
                  {" "}
                  {d.symbol}-({d.formal_name}){" "}
                </b>
              </div>
            ),

            value: d,
          }))}
          onChange={setSearch}
        />
      ) : (
        <div
          id="item_unit_search_display"
          className={`text-sm px-3 py-2  h-8 rounded focus:outline-none w-full border ${
            search ? "" : " text-gray-400 "
          }`}
          onClick={() => {
            if (!props.disabled) {
              setEdit(true);
              // setSearch(emp?.name ?? "");
            }
          }}
        >
          {search || props.placeholder || "Search"}
        </div>
      )}
      {addNew && (
        <ModalDialog
          onClose={() => {
            setAddNew(false);
          }}
          show={addNew}
          title={"Add Item Unit"}
        >
          <ItemUnitCreateScreen
            onClose={(d) => {
              if (d) {
                setEdit(false);
                setAddNew(false);
                setSearch(d.symbol);
                props.onSelect(d);
              }
            }}
          />
        </ModalDialog>
      )}
    </div>
  );
};

export default ItemUnitSearchField;
